import {
    StringInput,
    StringExport,
    NumberInput,
    NumberExport,
    NumberValue,
    StringValue,
    MaterialInput,
    MaterialExport,
    MaterialOutput,
    TemplateGraphInput,
    MathOperator,
    TemplateReference,
    MaterialReference,
} from "@cm/template-nodes"
import type {
    NumberLikeNode,
    StringLikeNode,
    TemplateInstance,
    MathOperatorParameters,
    NumberLike,
    StringLike,
    MaterialLikeNode,
    TemplateLikeNode,
    MetaData,
} from "@cm/template-nodes"

const toStringLikeNode = (v: StringLike): StringLikeNode => (typeof v === "string" ? new StringValue({parameters: {value: v}}) : v)
const toNumberLikeNode = (v: NumberLike): NumberLikeNode => (typeof v === "number" ? new NumberValue({parameters: {value: v}}) : v)

export const createStringInput = (name: string, id: string, defaultValue?: string, metaData?: MetaData) =>
    new StringInput({parameters: {name, id, default: defaultValue !== undefined ? toStringLikeNode(defaultValue) : undefined, metaData}})

export const createStringExport = (name: string, id: string, node: StringLike) => new StringExport({parameters: {name, node: toStringLikeNode(node), id}})

export const createNumberInput = (name: string, id: string, defaultValue?: number, metaData?: MetaData) =>
    new NumberInput({parameters: {name, id, default: defaultValue !== undefined ? toNumberLikeNode(defaultValue) : undefined, metaData}})

export function createNumberExport(name: string, id: string, node: NumberLike) {
    return new NumberExport({parameters: {name, node: toNumberLikeNode(node), id}})
}

export function createMaterialExport(name: string, id: string, node: MaterialLikeNode) {
    return new MaterialExport({parameters: {name, node, id}})
}

export function createMaterialOutput(name: string, outputId: string, template: TemplateInstance) {
    return new MaterialOutput({parameters: {name, outputId, template}})
}

export function createMathOperator(name: string, type: MathOperatorParameters["type"], inputA: NumberLike | null, inputB?: NumberLike | null) {
    return new MathOperator({parameters: {name, type, inputA, inputB: inputB !== undefined ? inputB : null}})
}

export const createMaterialInput = (name: string, id: string, metaData?: MetaData, defaultValue?: MaterialLikeNode) =>
    new MaterialInput({parameters: {name, id, metaData, default: defaultValue}})

export function createTemplateInput(name: string, id: string, defaultValue?: TemplateLikeNode, metaData?: MetaData) {
    return new TemplateGraphInput({parameters: {name, id, default: defaultValue, metaData}})
}

export function createNumberValue(value: number) {
    return new NumberValue({parameters: {value}})
}

export function createStringValue(value: string) {
    return new StringValue({parameters: {value}})
}

export function createTemplateReference(templateId: number, templateRevisionId: number | null = null) {
    return new TemplateReference({parameters: {templateId, templateRevisionId}})
}

export function createMaterialReference(materialId: number) {
    return new MaterialReference({parameters: {name: `Material ${materialId}`, materialId, materialRevisionId: null}})
}
